import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { MarkdownStyled } from '@core/components/Markdown/MarkdownTextWithParsedLinks/MarkdownTextWithParsedLinks.styled';

/** @type {(text: string) => string} */
const linkify = (text) => {
  return text.replace(
    /(?<!\]\()(?:(?:https?:\/\/)|www\.)[^\s<]+/gi,
    (match) => {
      const url = match.startsWith('www.') ? `https://${match}` : match;
      return `[${match}](${url})`;
    }
  );
};

/** @type {React.FC<{text: string}>} */
const MarkdownTextWithParsedLinks = ({ text }) => {
  const linkedText = useMemo(() => linkify(text), [text]);

  const handleClick = useCallback((e) => {
    e.stopPropagation();
  }, []);

  return (
    <MarkdownStyled
      options={{
        overrides: {
          a: {
            props: {
              target: '_blank',
              rel: 'noopener noreferrer',
              onClick: handleClick,
            },
          },
        },
      }}
    >
      {linkedText}
    </MarkdownStyled>
  );
};

MarkdownTextWithParsedLinks.propTypes = {
  text: PropTypes.string.isRequired,
};

export default MarkdownTextWithParsedLinks;
